// Constants
export const base = () => {
    return {
        base: {
            id: {
                namepath: ['admin_precios', 'aportes_registrar', 'aportes_cuentas', 'archivo_retiros'],
                description: 'id autoincrement',
                label: 'Id',
                readonly: true,
                type: 'number',
                datatype: {
                    predeterminate: ''
                }
            },
            base: {
                namepath: ['admin_precios', 'aportes_registrar', 'aportes_cuentas', 'configuracion'],
                type: 'number',
                label: 'Base de cotización',
                placeholder: '',
                description: 'Valor de afiliación',
                validate: '',
                datatype: {
                    type: 'price',
                    disabled: false,
                    predeterminate: 1160000,
                    prepend: '$',
                    append: '',
                }
            },
            admin: {
                namepath: ['admin_precios', 'aportes_registrar', 'aportes_cuentas'],
                type: 'number',
                label: 'Base admin exonerado',
                placeholder: '',
                description: 'Administración base exonerado',
                validate: '',
                datatype: {
                    type: 'price',
                    disabled: false,
                    predeterminate: 40000,
                    prepend: '$',
                    append: '',
                }
            },
            admin12: {
                namepath: ['admin_precios', 'aportes_registrar', 'aportes_cuentas'],
                type: 'number',
                label: 'Base admin no exonerado',
                placeholder: '',
                description: 'Administración base no exonerado',
                validate: '',
                datatype: {
                    type: 'price',
                    disabled: false,
                    predeterminate: 10000,
                    prepend: '$',
                    append: '',
                }
            },
            epsexo: {
                namepath: ['admin_precios', 'aportes_registrar', 'aportes_cuentas'],
                type: 'number',
                label: '% EPS Exónerado',
                placeholder: '',
                description: '% EPS Exónerado',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: 4,
                }
            },
            epsnoexo: {
                namepath: ['admin_precios', 'aportes_registrar', 'aportes_cuentas'],
                type: 'number',
                label: '% EPS Exónerado',
                placeholder: '',
                description: '% EPS Exónerado',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: 12.5,
                }
            },
            ccf: {
                namepath: ['admin_precios', 'aportes_registrar', 'aportes_cuentas'],
                type: 'number',
                label: '% EPS Exónerado',
                placeholder: '',
                description: '% EPS Exónerado',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: 4,
                }
            },
            afp: {
                namepath: ['admin_precios', 'aportes_registrar', 'aportes_cuentas'],
                type: 'number',
                label: '% EPS Exónerado',
                placeholder: '',
                description: '% EPS Exónerado',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: 16,
                }
            },
            r1: {
                namepath: ['admin_precios', 'aportes_registrar', 'aportes_cuentas'],
                type: 'number',
                label: '% Riesgo 1',
                placeholder: '',
                description: '% Riesgo 1',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: 0.522,
                }
            },
            r2: {
                namepath: ['admin_precios', 'aportes_registrar', 'aportes_cuentas'],
                type: 'number',
                label: '% Riesgo 2',
                placeholder: '',
                description: '% Riesgo 2',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: 1.044,
                }
            },
            r3: {
                namepath: ['admin_precios', 'aportes_registrar', 'aportes_cuentas'],
                type: 'number',
                label: '% Riesgo 3',
                placeholder: '',
                description: '% Riesgo 3',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: 2.436,
                }
            },
            r4: {
                namepath: ['admin_precios', 'aportes_registrar', 'aportes_cuentas'],
                type: 'number',
                label: '% Riesgo 4',
                placeholder: '',
                description: '% Riesgo 4',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: 4.35,
                }
            },
            r5: {
                namepath: ['admin_precios', 'aportes_registrar', 'aportes_cuentas'],
                type: 'number',
                label: '% Riesgo 5',
                placeholder: '',
                description: '% Riesgo 5',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: 6.96,
                }
            },
            afiliacion: {
                namepath: ['admin_precios', 'aportes_registrar', 'aportes_cuentas'],
                type: 'number',
                label: 'Valores de Afiliación',
                placeholder: '',
                description: '% Riesgo 5',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: 1,
                }
            },
            proporcional: {
                namepath: ['admin_precios', 'aportes_registrar', 'aportes_cuentas'],
                type: 'number',
                label: 'Administración en días proporcionales ',
                placeholder: '',
                description: '% Riesgo 5',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: 1,
                }
            },
            menos: {
                namepath: ['admin_precios', 'aportes_registrar', 'aportes_cuentas'],
                type: 'number',
                label: 'de 1 a 15 días ',
                placeholder: '',
                description: '% Riesgo 5',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: 0,
                }
            },
            mas: {
                namepath: ['admin_precios', 'aportes_registrar', 'aportes_cuentas'],
                type: 'number',
                label: 'de 15 a 25 días',
                placeholder: '',
                description: '% Riesgo 5',
                validate: '',
                datatype: {
                    type: 'input',
                    disabled: false,
                    predeterminate: 0,
                }
            },
        }
    }
}